
const Blog = () => {
    return (
        <div style={{height:"70vh"}}>
            <h4 style={{marginTop:"100px"}} className="text-info text-center">Coming soon...</h4>
        </div>
    );
};

export default Blog;